import { render, staticRenderFns } from "./ProductGeneralInfoList.vue?vue&type=template&id=12015660&scoped=true&"
import script from "./ProductGeneralInfoList.vue?vue&type=script&lang=js&"
export * from "./ProductGeneralInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12015660",
  null
  
)

export default component.exports